import _ from 'underscore';

import {RequestFulfillmentDefinition} from 'requests/fulfillments/FulfillmentConstants';

export function isFulfilmentDefinitionSelected(
  fulfillmentDefinition: RequestFulfillmentDefinition,
  selectedFulfillmentDefinitions: Array<RequestFulfillmentDefinition>
): boolean {
  return _.findWhere(selectedFulfillmentDefinitions, {cid: fulfillmentDefinition.cid}) != null;
}

/**
 * Immutably toggle the selection for the specified fulfillmentDefinition and return the new selection.
 */
export function toggleFulfillmentDefinitionSelection(
  fulfillmentDefinition: RequestFulfillmentDefinition,
  selectedFulfillmentDefinitions: Array<RequestFulfillmentDefinition>
): Array<RequestFulfillmentDefinition> {
  if (isFulfilmentDefinitionSelected(fulfillmentDefinition, selectedFulfillmentDefinitions)) {
    return selectedFulfillmentDefinitions.filter(
      (definition) => definition.cid !== fulfillmentDefinition.cid
    );
  }
  return [...selectedFulfillmentDefinitions, fulfillmentDefinition];
}

export function toggleHeaderCheckboxSelection(
  fulfillmentDefinitions: Array<RequestFulfillmentDefinition>,
  selectedFulfillmentDefinitions: Array<RequestFulfillmentDefinition>
): Array<RequestFulfillmentDefinition> {
  const allSelected = fulfillmentDefinitions.every((definition) =>
    isFulfilmentDefinitionSelected(definition, selectedFulfillmentDefinitions)
  );
  return allSelected ? [] : fulfillmentDefinitions;
}
